<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="display-xl">
            {{
              $t('comingSoon.greetingHeading', previousLocale, { countryName: currentCountryName })
            }}
            <span class="color-orange-high">{{
              $t('comingSoon.comingSoonHeading', previousLocale)
            }}</span>
          </h1>
          <p class="margin-bottom-lg">
            {{ $t('comingSoon.subheading', previousLocale) }}
          </p>
          <ul>
            <li class="margin-bottom-sm">
              <al-icon-text icon="icon-src" variant="sm" wide name="icon-text-src">
                {{ $t('comingSoon.clickToPayItem', previousLocale) }}
              </al-icon-text>
            </li>
            <li class="margin-bottom-sm">
              <al-icon-text icon="icon-wallet" variant="sm" wide name="icon-text-wallet">
                {{ $t('comingSoon.storePaymentInfoItem', previousLocale) }}
              </al-icon-text>
            </li>
            <li>
              <al-icon-text icon="icon-cart" variant="sm" wide name="icon-text-cart">
                {{ $t('comingSoon.speedThroughCheckoutItem', previousLocale) }}
              </al-icon-text>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlIconText } from '@mc-alberta/alcapone'
import { mapState } from 'vuex'
import { ROUTES } from '@/constants'

export default {
  name: 'ComingSoon',
  components: { AlIconText },
  computed: {
    ...mapState({
      currentCountry: (state) => state.user.consumer.countryCode,
      previousLocale: (state) => state.user.previousLocale,
      waitingForLocaleSelection: (state) => state.isLocaleSelectorSelected
    }),
    currentCountryName() {
      const { countryCode } = this.$i18nData.getLocaleParts(this.previousLocale) || {}
      return this.$i18nData.getCountryName(countryCode || this.currentCountry)
    }
  },
  watch: {
    /**
     * Redirect if country is supported
     */
    waitingForLocaleSelection: {
      immediate: true,
      handler(isLocaleConfirmed) {
        if (!isLocaleConfirmed && this.$i18nData.isCountryLive(this.currentCountry)) {
          this.$router.replace({ name: ROUTES.ENTRY })
        }
      }
    }
  }
}
</script>
